<template>
  <div :class="ismobile ? 'hotwork' : 'hotmo'">
    <div class="banner">
      <el-carousel :height="ismobile ? '320px' : '160px'">
        <el-carousel-item v-for="item in swiper" :key="item.id">
          <img
            class="banners"
            :src="'https://hcrl.huicairen.net' + item.img"
            alt=""
          />
        </el-carousel-item>
      </el-carousel>
      <!-- <div>
        <img class="banners" src="../static/home_banner_bg.png" alt="" />
      </div> -->
    </div>
    <div class="address">
      <img class="icons" src="../static/address_icon.png" alt="" />
      您所在的位置：热招职位
    </div>
    <!-- 筛选 -->
    <div class="choose_list">
      <div class="choose_item">
        <div class="names">地域选择:</div>
        <el-cascader
          size="large"
          :options="area"
          v-model="selectedOptions"
          @change="handleChange"
        >
        </el-cascader>
        <!-- <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
      </div>
      <div class="choose_item">
        <div class="names">工作类型:</div>
        <el-select
          @change="changevalue"
          v-model="worktype"
          placeholder="请选择"
        >
          <el-option
            v-for="item in cateList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="choose_items">
        <div class="names">计薪方式:</div>
        <div class="divss">
          <el-select @change="changetype" v-model="type" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.value"
              :value="item.label"
            >
            </el-option>
          </el-select>
          <el-select @change="changesort" v-model="sort" placeholder="请选择">
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.value"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <!-- 职位列表 -->
    <div class="work_list">
      <div v-for="item in workList" :key="item.id" style="width: 100%">
        <work :rows="item" @free="frees" @todetails="todetails" />
      </div>
      <div class="block">
        <el-pagination
          background
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          :layout="ismobile ? layoutpc : layoutmo"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 报名弹窗 -->
    <el-dialog
      title=""
      :visible.sync="centerDialogVisible"
      :width="ismobile ? '530px' : '265px'"
      center
    >
      <div class="baomings">
        <div class="title">入职报名表单</div>
        <div class="p2">我们是正规渠道，直接招聘入职</div>
        <div>
          <input
            class="inp"
            v-model="name"
            type="text"
            name=""
            id=""
            placeholder="您的姓名"
          />
        </div>
        <div>
          <input
            class="inp"
            v-model="phone"
            type="text"
            name=""
            id=""
            placeholder="您的电话"
          />
        </div>
        <div class="submits" @click="submits">提交表单</div>
      </div>
    </el-dialog>
    <!-- 提交弹窗 -->
    <el-dialog
      title="申请免费入职"
      :visible.sync="issubmits"
      :width="ismobile ? '360px' : '200px'"
      center
      top="250px"
    >
      <div style="texts">
        {{ text }}
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
        <el-button
          style="background-color: #da251c; color: #fff"
          @click="issubmits = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import work from "./work.vue";
import { regionData, CodeToText } from "element-china-area-data";
export default {
  name: "",
  props: {},
  components: { work: work },
  data() {
    return {
      layoutpc: "sizes,total, prev, pager, next, jumper",
      layoutmo: "total, prev, pager, next",
      text: "您的报名信息已提交，我们的招聘顾问会尽快与您 取得联系！",
      swiper: [],
      area: regionData,
      selectedOptions: [],
      type: "",
      sort: "",
      total: 0,
      worktype: "",
      name: "",
      phone: "",
      issubmits: false,
      centerDialogVisible: false,
      cateList: [],
      workList: [],
      options: [
        {
          value: "小时工",
          label: "1",
        },
        {
          value: "同工同薪",
          label: "2",
        },
      ],
      options1: [
        {
          value: "价格升序",
          label: "1",
        },
        {
          value: "价格降序",
          label: "2",
        },
      ],
      value: "",
      currentPage: 1,
      works: "",
      windowWidth: document.documentElement.clientWidth,
    };
  },
  computed: {
    ismobile() {
      console.log(this.windowWidth);
      if (this.windowWidth > 500) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {},
  methods: {
    submits() {
      if (!this.name || !this.phone) {
        this.$message.error("请输入完整的信息");
        return;
      }
      this.$api
        .position({
          name: this.name,
          tel: this.phone,
          flag: 1,
          position_id: this.works.id,
        })
        .then((data) => {
          console.log(data);
          if (data.data.code == 0) {
            this.text =
              "您的报名信息已提交，我们的招聘顾问会尽快与您 取得联系！";
          } else {
            this.text = data.data.msg;
          }
          this.issubmits = true;
        });
    },
    handleChange() {
      var loc = [];
      // console.log(this.selectedOptions);
      for (let i = 0; i < this.selectedOptions.length; i++) {
        loc.push(CodeToText[this.selectedOptions[i]]);
      }
      let province = loc[0];
      let city = loc[1];
      let county = loc[2];
      console.log(province, city, county);
      if (county) {
        // console.log(1);
        this.getList({ county });
      } else if (city) {
        this.getList({ city });
      } else {
        this.getList({ province });
      }
    },
    todetails(item) {
      this.$router.push({
        path: "/hotwork/workdetail",
        query: { id: item.id },
      });
    },
    frees(item) {
      this.centerDialogVisible = true;
      this.works = item;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList({ m: val });
    },
    changevalue(e) {
      // console.log(e);
      this.getList({ cate_id: e });
    },
    changetype(e) {
      // console.log(e, this.type);
      this.getList({ cate_name: e });
    },
    changesort(e) {
      this.getList({ sort: e });
    },
    getbanner() {
      this.$api.banner().then((data) => {
        console.log(data, "轮播图");
        if (data.data.code == 0) {
          this.swiper = data.data.data;
        } else {
          this.$message.error(data.data.msg);
        }
      });
    },

    getcate() {
      this.$api.pocate().then((data) => {
        if (data.data.code == 0) {
          this.cateList = data.data.data.data;
        } else {
          this.$message.error(data.data.msg);
        }
      });
    },
    getList(obj) {
      this.$api.lists(obj).then((data) => {
        console.log(data, "职位列表");
        if (data.data.code == 0) {
          this.workList = data.data.data.data;
          this.total = data.data.data.count;
        } else {
          this.$message.error(data.data.msg);
        }
      });
    },
  },
  created() {
    this.getcate();
    this.getList();
    this.getbanner();
  },
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="less" scoped>
/deep/.el-dialog--center {
  border-radius: 10px;
}
.texts {
  text-align: center;
}
// 手机
.hotmo {
  width: 100%;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  .banner {
    width: 100%;
    height: 160px;
    //   font-size: 0px;
    //   margin-bottom: 40px;
    .banners {
      width: 100%;
      height: 160px;
      // font-size: 0px;
    }
  }
  .address {
    width: 100%;
    height: 40px;
    background: #ffffff;
    padding-left: 15px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666666;
    box-sizing: border-box;
    .icons {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }
  .choose_list {
    width: 100%;
    // display: flex;
    // align-items: center;
    // justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 0 20px;
    box-sizing: border-box;
    .choose_item {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      font-size: 16px;
      color: #333333;
      /deep/.el-input--suffix .el-input__inner {
        width: 120px;
        box-sizing: border-box;
        // margin-left: 10px;
      }
    }
    .names {
      width: 24%;
      // margin-right: 4px;
    }
    .divss {
      width: 76%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .choose_items {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;
      font-size: 16px;
      color: #333333;
      /deep/.el-input--suffix .el-input__inner {
        width: 120px;
        box-sizing: border-box;
        // margin-left: 5px;
      }
      // text-align: right;
    }
    // .names {
    //   width: 20%;
    // }
  }
  // 职位列表
  .work_list {
    width: 100%;
    //   height: auto;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 30px;
    box-sizing: border-box;
  }
  .block {
    margin-top: 25px;
    margin-bottom: 25px;
    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #da251c;
    }
  }
  // 报名弹窗
  .baomings {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      font-size: 22px;
      color: #da251c;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .p2 {
      color: #333333;
      font-size: 18px;
      text-align: center;
    }
    .inp {
      width: 180px;
      height: 40px;
      border: 2px solid #7d7d7d;
      border-radius: 10px;
      padding-left: 14px;
      box-sizing: border-box;
      margin-top: 20px;
    }
    .submits {
      width: 170px;
      height: 40px;
      background: #da251c;
      border-radius: 10px;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
      margin-top: 20px;
      cursor: pointer;
    }
  }
}

// pc
.hotwork {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .banner {
    width: 100%;
    height: 320px;
    //   font-size: 0px;
    //   margin-bottom: 40px;
    .banners {
      width: 100%;
      height: 320px;
      // font-size: 0px;
    }
  }
  .address {
    width: 100%;
    height: 40px;
    background: #ffffff;
    padding-left: 158px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666666;
    box-sizing: border-box;
    .icons {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }
  // 筛选
  .choose_list {
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 40px;
    margin-bottom: 40px;
    .choose_item {
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #333333;
    }
    .choose_items {
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #333333;
    }
    /deep/.el-input--suffix .el-input__inner {
      width: 180px;
      box-sizing: border-box;
      margin-left: 10px;
    }
  }
  // 职位列表
  .work_list {
    width: 80%;
    //   height: auto;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 40px;
    margin-bottom: 60px;
    box-sizing: border-box;
  }
  .block {
    margin-top: 50px;
    margin-bottom: 50px;
    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #da251c;
    }
    /deep/.el-pagination button,
    .el-pagination span:not([class*="suffix"]) {
      // display: inline;
      padding: 0 10px;
      // padding: 10px;
      // box-sizing: border-box;
    }
  }
  // 报名弹窗
  .baomings {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      font-size: 36px;
      color: #da251c;
      font-weight: bold;
      margin-bottom: 40px;
    }
    .p2 {
      color: #333333;
      font-size: 24px;
    }
    .inp {
      width: 362px;
      height: 54px;
      border: 2px solid #7d7d7d;
      border-radius: 10px;
      padding-left: 14px;
      box-sizing: border-box;
      margin-top: 20px;
    }
    .submits {
      width: 340px;
      height: 40px;
      background: #da251c;
      border-radius: 10px;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
      margin-top: 20px;
      cursor: pointer;
    }
  }
}
</style>
